'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PedestalIcon = function PedestalIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M48 78h9v6h-9zM51 99h29v7H51zM46 18h38v20H46zM61 38h8v60h-8z'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                fillRule: 'nonzero',
                d: 'M87.143 52.308V50h16.699v58.093H26.624V50h16.23v2.308H28.932v53.477h72.602V52.308z'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                fillRule: 'nonzero',
                d: 'M108.158 45.857H87.08V43.55h23.384v70.993H20.001V43.55h22.833v2.307H22.309v66.379h85.849z'
            }),
            _react2.default.createElement('path', {
                d: 'M82.96 37.353H47.505v-18.87H82.96v18.87zm-15 53.132v7.08h-5.454v-58.14h5.453v51.06zm-7.4 3.859v3.22H50.88c-.979 0-1.765.794-1.765 1.77v7.083c0 .974 1.018.767 1.997.767h28.244c.976 0 2.167.207 2.167-.767v-7.082a1.77 1.77 0 0 0-1.767-1.77H70.03V39.424h13.4c.973 0 1.762-.793 1.762-1.772v-19.47c0-.976-.789-1.77-1.763-1.77H47.038c-.979 0-1.768.794-1.768 1.77v19.47c0 .979.79 1.772 1.768 1.772H60.56v54.92zm10.805 5.068h8.038v6.107H51.27v-6.107h20.095z',
                fill: '#555'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                fillRule: 'nonzero',
                d: 'M84.395 61.973v2.1H28.302v-2.1zM102.164 61.973v2.1h-5.578v-2.1zM93.349 61.973v2.1H87.77v-2.1z'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                fillRule: 'nonzero',
                d: 'M51.471 38.537h2.1v38.176h-2.1z'
            }),
            _react2.default.createElement('path', {
                d: 'M54.801 84.06c.647 0 1.199-.59 1.199-1.349v-3.304c0-.759-.552-1.348-1.199-1.348H50.2c-.647 0-1.199.59-1.199 1.348v3.304c0 .76.552 1.348 1.199 1.348H54.8zm0 2H50.2C48.417 86.06 47 84.545 47 82.71v-3.304c0-1.835 1.417-3.348 3.199-3.348H54.8c1.782 0 3.199 1.513 3.199 3.348v3.304c0 1.835-1.417 3.348-3.199 3.348z',
                fill: '#555',
                fillRule: 'nonzero'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                d: 'M55.538 32.157h1.944V30.04h-1.944z'
            }),
            _react2.default.createElement('path', {
                d: 'M54.962 32.734v-3.27h3.096v3.27h-3.096zm1.943-1.154v-.963h-.79v.963h.79z',
                fill: '#555',
                fillRule: 'nonzero'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                d: 'M64.262 32.157h1.943V30.04h-1.943z'
            }),
            _react2.default.createElement('path', {
                d: 'M63.685 32.734v-3.27h3.097v3.27h-3.097zm1.943-1.154v-.963h-.79v.963h.79z',
                fill: '#555',
                fillRule: 'nonzero'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                d: 'M72.982 32.157h1.943V30.04h-1.943z'
            }),
            _react2.default.createElement('path', {
                d: 'M72.405 32.734v-3.27h3.097v3.27h-3.097zm1.943-1.154v-.963h-.789v.963h.79z',
                fill: '#555',
                fillRule: 'nonzero'
            })
        )
    );
};

PedestalIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg'
};

var Pedestal = function (_React$Component) {
    _inherits(Pedestal, _React$Component);

    function Pedestal() {
        _classCallCheck(this, Pedestal);

        return _possibleConstructorReturn(this, (Pedestal.__proto__ || Object.getPrototypeOf(Pedestal)).apply(this, arguments));
    }

    _createClass(Pedestal, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(PedestalIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return Pedestal;
}(_react2.default.Component);

exports.default = Pedestal;